function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "glass"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20 6c0-1.152-.19-2.274-.567-3.335-.142-.398-.52-.665-.943-.665h-12.98c-.424 0-.802.267-.943.666-.376 1.062-.567 2.184-.567 3.334 0 4.581 3.06 8.365 7 8.922v5.078h-3c-.552 0-1 .447-1 1s.448 1 1 1h8c.553 0 1-.447 1-1s-.447-1-1-1h-3v-5.078c3.939-.557 7-4.341 7-8.922zm-14 0c0-.684.083-1.354.25-2h11.501c.165.646.249 1.315.249 2 0 3.859-2.691 7-6 7s-6-3.141-6-7z"
}));

var Svg050Glass = function Svg050Glass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg050Glass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/050-glass.c49f0097.svg";
export { ForwardRef as ReactComponent };